// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Fa8TC{padding:0 16px 32px;margin:0}@media screen and (min-width:1024px){.Fa8TC{min-width:250px;padding:24px 16px;background:#232323;border-radius:8px;text-align:left}}.I0jce{padding-top:16px;color:#989898;font-size:14px;font-weight:400;line-height:24px}.I0jce:after{content:\":\"}.I0jce:first-of-type{padding-top:0}.UNdiO{padding-bottom:16px;border-bottom:1px solid #2d2d2d;margin:0;color:#fff;font-family:\"Merriweather\",serif;font-size:18px;font-weight:700;line-height:28px}@media screen and (min-width:1024px){.UNdiO{padding:0;border:0;line-height:22px}}._3tAsX{margin-top:24px;font-weight:400}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "Fa8TC",
	"key": "I0jce",
	"value": "UNdiO",
	"profileLink": "_3tAsX"
};
module.exports = ___CSS_LOADER_EXPORT___;
